import * as React from 'react';
import { rem } from 'polished';
import AsyncSelect from '../../AsyncSelect';
import Checkbox from '../../Checkbox';
import Label from '../../Label/Label';
import LabelComponent from '../../TheSelect/components/Label';
import Select from '../../TheSelect';
import styled, { css } from 'styled-components';
const StyledLabel = styled(Label) `
  cursor: pointer;
  margin-bottom: ${rem(10)};
  padding-top: 5px;
  font-weight: normal;
  ${({ disabled }) => disabled &&
    css `
      cursor: not-allowed;
    `};
`;
const SelectFilter = ({ onChange, value, filter: { onBlur, ...filter }, }) => {
    function handleCheckbox(e, filter) {
        const targetValue = e.target.value;
        const values = value || [];
        const isInValues = typeof values.find(o => o.value === targetValue) !== 'undefined';
        const option = filter['options'].find(o => o.value === targetValue);
        if (!option) {
            return;
        }
        if (e.target.checked) {
            if (!isInValues) {
                values.push(option);
                onChange(values);
            }
        }
        else {
            const idx = values.findIndex(o => o.value === targetValue);
            if (idx > -1) {
                const nextValues = [...values.slice(0, idx), ...values.slice(idx + 1)];
                onChange(nextValues);
            }
        }
    }
    function handleRadio(e, filter) {
        if (e.target.checked) {
            const option = filter['options'].find(o => o.value === e.target.value);
            if (option) {
                onChange(option);
            }
        }
        else {
            onChange(null);
        }
    }
    if (filter.async) {
        return React.createElement(AsyncSelect, { ...filter, value: value, onChange: onChange });
    }
    else if (filter.options.length >= 6) {
        return React.createElement(Select, { ...filter, value: value, onChange: onChange });
    }
    else if (filter.multiple) {
        return (React.createElement(React.Fragment, null, filter.options.map((f, idx) => (React.createElement(StyledLabel, { ...filter, key: `select-${f.value}-${idx}` },
            React.createElement(Checkbox, { ...filter, value: f.value === null ? '$null' : f.value, onChange: e => {
                    handleCheckbox(e, filter);
                }, checked: !!value && !!value.find(o => o.value === f.value) }),
            React.createElement(LabelComponent, { ...filter, label: f.label, icon: f.icon, iconSize: 14, labelSize: 16 }))))));
    }
    else {
        return (React.createElement(React.Fragment, null, filter.options.map((f, idx) => (React.createElement(StyledLabel, { ...filter, key: `select-${f.value}-${idx}` },
            React.createElement("input", { ...filter, type: "radio", value: f.value === null ? '$null' : f.value, name: filter.name, checked: !!value && value.value === f.value, onChange: e => {
                    handleRadio(e, filter);
                } }),
            React.createElement(LabelComponent, { ...filter, label: f.label, icon: f.icon, iconSize: 14, labelSize: 16 }))))));
    }
};
export default SelectFilter;
